export enum SliderSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SliderVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export const SLIDER_SIZES = {
  [SliderSize.SMALL]: {
    trackHeight: 0.5,
    thumbSize: 3,
    thumbHoverSize: 2.5,
  },
  [SliderSize.MEDIUM]: {
    trackHeight: 1.5,
    thumbSize: 5,
    thumbHoverSize: 3,
  },
} as const;
